import { render } from "./tshirtroster.vue?vue&type=template&id=e0be7f42&scoped=true"
import script from "./tshirtroster.vue?vue&type=script&lang=js"
export * from "./tshirtroster.vue?vue&type=script&lang=js"

import "./tshirtroster.vue?vue&type=style&index=0&id=e0be7f42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0be7f42"]])

export default __exports__